import { render, staticRenderFns } from "./FreightRate.vue?vue&type=template&id=5ee2c848&scoped=true"
import script from "./FreightRate.vue?vue&type=script&lang=js"
export * from "./FreightRate.vue?vue&type=script&lang=js"
import style0 from "./FreightRate.vue?vue&type=style&index=0&id=5ee2c848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee2c848",
  null
  
)

export default component.exports